//export const baseUrl = "https://devworkshop.vjoinlife.com/api/";

 export const baseUrl = "https://visioateliersnumeriques.com/api/";

